import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

import {
  getPremiumStyled,
  RETURN_DISPLAY,
  RETURN_VALUE_ONLY,
} from 'enrollment/utils';
import { selectPerPayPeriodText } from 'enrollment/services';
import { CategoryColorSplash } from '../BenefitsPreviewV2';
import { CategoryPremiumStyled } from './CategoriesV2ContainerStyled';

export interface CategoriesV2ContainerProps {
  groupName: string;
  children: React.ReactNode;
  categoryTotal: number;
  color: string;
  id?: string;
  dataTestId?: string;
  loading?: boolean;
  className?: string;
  extraTopContent?: React.ReactNode;
}

export const CategoriesV2Container = ({
  groupName,
  children,
  color,
  id,
  dataTestId,
  loading,
  className,
  categoryTotal,
  extraTopContent,
}: CategoriesV2ContainerProps) => {
  return (
    <div
      id={id}
      className={`card ${className} position-relative`}
      data-testid={dataTestId || 'generic-grouping-container'}
    >
      <div>
        <CategoryColorSplash color={color} />
        {extraTopContent}
        <div className="d-flex flex-row justify-content-between align-items-center mb-3">
          <h2 className="oswald-font">
            {groupName || (
              <Skeleton variant="text" role="status" aria-label="Loading..." />
            )}
          </h2>
          <CategoryPremiumStyled>
            <span aria-live="polite" id="running-total">
              {getPremiumStyled({
                premium: String(categoryTotal),
                valueOnly: RETURN_VALUE_ONLY,
              })}
            </span>
          </CategoryPremiumStyled>
        </div>

        {!loading ? (
          children
        ) : (
          <Skeleton
            variant="rectangular"
            height={300}
            role="status"
            aria-label="Loading..."
          />
        )}
      </div>
    </div>
  );
};
